import "./index.css";
import { BudgetApp } from "./BudgetApp";

export function App() {
  return <BudgetApp />;
}

export default App;
